'use client';

import { useState } from 'react';
import { DefectModal } from '@/components/defect-modal';
import { NotProductionBoundry } from '@/components/not-production-boundry/base';
import { Button } from '@/components/button';

export const FoundABug = () => {
  const [isDefectModalOpen, setIsDefectModalOpen] = useState<boolean>(false);

  return (
    <NotProductionBoundry>
      <DefectModal
        isModalOpen={isDefectModalOpen}
        setIsModalOpen={setIsDefectModalOpen}
      />
      <Button
        size="sm"
        className="!fixed bottom-4 right-4 bg-pink-600"
        onClick={() => {
          setIsDefectModalOpen(true);
        }}
      >
        FOUND A BUG
      </Button>
    </NotProductionBoundry>
  );
};
